<template>
  <div class="loginPage">
    <router-link class="fixedLink" to="/register">注册</router-link>
    <div class="logo">
      <!--91x92-->
      <van-image width="2.4267rem" height="2.4533rem" :src="logo" />
    </div>

    <van-field
      v-model="tel"
      clearable
      placeholder="请填写手机号"
      :border="input_border"
    />
    <van-field
      v-model="password"
      clearable
      type="password"
      placeholder="请填写密码"
      :border="input_border"
      right-icon="question-o"
      @click-right-icon="$toast('请填写6位以上数字+字母的密码')"
    />

    <div class="links">
      <router-link class="left" to="/telVerify?status=1"
        >短信验证登录</router-link
      >
      <router-link class="right" to="/telVerify?status=0" dongta
        >忘记密码？</router-link
      >
    </div>
    <van-button
      type="warning"
      size="large"
      class="btn"
      :loading="login_loading"
      loading-text="正在登录..."
      @click="onClickButtonSubmit"
      >登录</van-button
    >
    <van-button
      type="default"
      size="large"
      class="btn firstTime"
      to="/telVerify?status=1"
      >首次登录</van-button
    >
    <div class="privacy">
      <van-checkbox
        v-model="isSelected"
        icon-size="12px"
        style="font-size:13px"
        label-disabled
        >已阅读并同意
        <router-link style="color: #c0c8ff;font-size:13px" to="/privacy"
          >《{{ platformName }}隐私政策》</router-link
        >
      </van-checkbox>
    </div>
  </div>
</template>
<script>
import { Image, Button, Field, Toast, Icon, Checkbox } from 'vant'
import { Notify } from 'vant'
import { rsaEncrypt } from '@/utils/rsa'
import { ecompanyGetLogoByCode } from '@/api/ecompany/request'
import { ocompanyGetLogoByCode } from '@/api/ocompany/request'
import api from '@/api/list'
import { setPassLoginFlagCode, getCompanyCodeHeaderKey } from '@/utils/auth'

export default {
  components: {
    [Image.name]: Image,
    [Button.name]: Button,
    [Field.name]: Field,
    [Toast.name]: Toast,
    [Icon.name]: Icon,
    [Notify.name]: Notify,
    [Checkbox.name]: Checkbox,
  },
  watch: {
    tel: {
      handler: function() {
        localStorage.setItem('this.tel', JSON.stringify(this.tel))
      },
    },
  },
  data() {
    return {
      isSelected: false,
      iconPath: process.env.VUE_APP_FILE_PATH,
      input_border: false,
      logo: require('@/assets/logo.png'),
      tel: '',
      password: '',
      login_loading: false,
      platformName: '工蚁宝',
      message: {
        tel: '',
        password: '',
      },
    }
  },
  created() {
    this.initLogo()
    this.getPageData()
  },
  methods: {
    getPageData() {
      this.tel = JSON.parse(localStorage.getItem('this.tel')) //使用getItem方法的前提是，你再自己需要的地方使用了setItem方法
    },
    initLogo() {
      let companyCodeHeader = getCompanyCodeHeaderKey() // 从响应头中读取
      let ecompanyCode = this.$store.getters.ecompanyCode //this.$route.query.ecompanyCode;
      let ocompanyCode = this.$store.getters.ocompanyCode //this.$route.query.ocompanyCode;
      if (
        (ecompanyCode == null || ecompanyCode == '') &&
        companyCodeHeader != null &&
        companyCodeHeader != 'null'
      ) {
        // 定制化企业将企业编码配置在请求头中
        ecompanyCode = companyCodeHeader
      }
      if (ecompanyCode) {
        this.platformName = '灵工平台'
        //&& typeof ocompanyCode == "undefined"
        ecompanyGetLogoByCode({ code: ecompanyCode }).then((res) => {
          if (res.data.status == '200') {
            this.logo = this.iconPath + res.data.data
          }
        })
      } else if (ocompanyCode) {
        //&& typeof ecompanyCode == "undefined"
        ocompanyGetLogoByCode({ code: ocompanyCode }).then((res) => {
          if (res.data.status == '200') {
            this.logo = this.iconPath + res.data.data
          }
        })
      }
    },
    onClickButtonSubmit() {
      if (!this.isSelected) {
        this.$toast('请勾选协议!')
        return false
      }
      if (this.tel == '') {
        this.$toast('手机号码不能为空')
        return false
      }
      if (this.password == '') {
        this.$toast('密码不能为空')
        return false
      }
      this.$store.commit('SET_USER_INFO', {})
      let parm = { tel: this.tel, password: this.password, type: 'password' }
      let temp = JSON.parse(JSON.stringify(parm))
      // 加密数据
      temp.password = encodeURIComponent(rsaEncrypt(temp.password))
      ;(this.login_loading = true),
        this.$store
          .dispatch('Login', temp)
          .then((res) => {
            if (res.status == '200') {
              setPassLoginFlagCode(1)
              api.getAccountIdntityType().then((res) => {
                if (res.data.status == '200') {
                  this.$store.dispatch('getUserInfo')
                  let path =
                    this.$store.getters.enterRoute &&
                    this.$store.getters.enterRoute !== undefined &&
                    this.$store.getters.enterRoute !== null
                      ? this.$store.getters.enterRoute
                      : '/'
                   if(path.indexOf('token=')!=-1){
                     path ='/'
                   }
                  switch (res.data.data.identityType) {
                    // 普通灵活用工
                    case 'COMMON_EMPLOYEE':
                      window.location.href = `${document.location.origin}/index.html#${path}`
                      break
                    //个体户用工
                    case 'INDIVIDUAL_BUSINESSES':
                      window.location.href = `${document.location.origin}/index1.html#${path}`
                      break
                    //同时具有双重身份
                    case 'DOUBLE_IDENTITY':
                      switch (res.data.data.lastMode) {
                        // 普通灵活用工
                        case 1:
                          window.location.href = `${document.location.origin}/index.html#${path}`
                          break
                        //个体户用工
                        case 2:
                          window.location.href = `${document.location.origin}/index1.html#${path}`
                          break
                        case null:
                          this.$router.push({
                            path: '/individual_choose',
                            query: { srcPath: path },
                          })
                          break
                      }
                      break
                    default:
                      window.location.href = `${document.location.origin}/index.html#/home`
                  }
                }
              })
            } else {
              this.$toast(res.message)
            }
            this.login_loading = false
          })
          .catch(() => {
            this.login_loading = false
          })
    },
  },
  mounted: function() {
    document.getElementsByTagName('body')[0].className = 'login_bg'
  },
  beforeDestroy: function() {
    document.body.removeAttribute('class', 'login_bg')
  },
}
</script>
<style lang="less">
.loginPage .privacy {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 0.42rem;
}
.loginPage .privacy .van-checkbox__icon .van-icon {
  border: 0.02667rem solid #fff;
}
.loginPage .privacy span.van-checkbox__label {
  color: #ffffff;
}
</style>
<style lang="less" scoped>
.loginPage {
  display: block;
  padding: 20px 44px;

  .fixedLink {
    position: absolute;
    right: 0;
    top: 10px;
    width: 80px;
    font-size: 16px;
    color: #fff;
    text-align: center;
    line-height: 40px;
  }

  .logo {
    display: block;
    width: 91px;
    margin: 0 auto 48px;
  }

  .links {
    overflow: hidden;
    a {
      font-size: 13px;
      color: #fff;

      &.left {
        float: left;
      }

      &.right {
        float: right;
      }
    }
  }

  .btn {
    margin-top: 60px;
    &.firstTime {
      background: #25bfff;
      border: 1px solid #25bfff;
      color: #fff;
    }
  }
}
</style>
<style lang="less">
.loginPage {
  .van-cell {
    margin-bottom: 10px;
    border-radius: 6px;
    padding: 11px 25px;
  }
}
</style>
